
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  getRoleList,
  quicklyCreateRole,
  deleteRole
} from '@/api/users';
import { UserModule } from '../../store/modules/user';
import { parseTime } from '../../utils/index';

import dialogSetStaff from './components/setStaff.vue';
import dialogSetRoleName from './components/setRoleName.vue';
import dialogSetInvite from './components/setInvite.vue';
import { getCompanyLimit } from '@/api/company';

@Component({
  name: 'StaffRole',
  components: {
    dialogSetStaff,
    dialogSetRoleName,
    dialogSetInvite
  }
})
export default class extends Vue {
  // 页面参数定义
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };
  private isServer=false;

  private limitString='';
  created() {
    if (UserModule.getCompany) {
      let vipLevel = (UserModule.getCompany as any).vip_level;
      this.isServer = vipLevel.substr(0, 1) !== '1';
    }
    this.getRoleList();
    this.getCompanyLimit();
  }
  // --------搜索---------
  private formSearch = {
    name: ''
  };
  handleSearch() {
    this.pagination.currentPage = 1;
    this.getRoleList();
  }
  handleClear() {
    this.pagination.currentPage = 1;
    this.formSearch = {
      name: ''
    };
    this.getRoleList();
  }
  // --------搜索---------
  // --------版本限制---------

  getCompanyLimit() {
    const parameters:any = {};
    parameters.company_id = UserModule.getCompanyId;
    parameters.user_id = UserModule.getUserId;
    getCompanyLimit(parameters)
      .then(res => {
        if (res.data) {
          this.limitString = '当前版本 权限人数共' + res.data.set_role_user_number + '人（包括管理员）；已添加' + (parseInt(res.data.all_role_user_number) + 1) + '人';
        }
      })
      .catch(err => {
        let msg = err.msg;
      });
  }
  // --------版本限制---------
  // --------邀请人员---------
  // 邀请人员
  private dialogInviteVisible = false;
  inviteHandle() {
    this.dialogInviteVisible = true;
  }
  closeInvite(value: boolean) {
    this.dialogInviteVisible = value;
  }
  // --------邀请人员---------
  // --------获取列表---------
  private handlePageSizeChange(pageSize:any) {
    this.pagination.pageSize = pageSize;
    this.getRoleList();
  }
  private handleCurrentChange(page:any) {
    this.pagination.currentPage = page;
    this.getRoleList();
  }
  private tableData: any = [];
  getRoleList() {
    const params = {
      name: this.formSearch.name,
      company_id: UserModule.getCompanyId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize
    };
    getRoleList(params)
      .then(res => {
        if (res.data) {
          this.tableData = (res as any).data.list;
          this.pagination.total = res.data.count;
          this.paseData(this.tableData);
        } else {
          this.tableData = [];
        }
      })
      .catch(err => {
        let msg = err.msg;
      });
  }
  paseData(val: any) {
    for (let i = 0; i < val.length; i++) {
      let cont: any = val[i];
      let name: string = '';
      for (let temp of cont.userArr) {
        name += temp.name + ',';
      }
      if (name) {
        name = String(name).substring(0, String(name).length - 1);
        cont.userArrName = name;
      }
      cont.addTimeStr = parseTime(cont.addtime, '{y}-{m}-{d} {h}:{i}');
      this.$set(this.tableData, cont, i);
    }
  }
  // --------获取列表---------
  // --------添加/编辑角色---------
  private dialogSetRoleNameVisible = false;
  private roleId = '';
  editRoleHandle(val: any) {
    this.roleId = val.id;
    this.dialogSetRoleNameVisible = true;
  }
  addRoleHandle() {
    // 添加角色
    this.dialogSetRoleNameVisible = true;
  }
  closeRole(value: boolean) {
    this.roleId = '';
    this.dialogSetRoleNameVisible = value;
  }
  createRole(value: boolean) {
    this.closeRole(value);
    this.getRoleList();
    this.getCompanyLimit();
  }
  editRole(value: boolean) {
    this.closeRole(value);
    this.getRoleList();
    this.getCompanyLimit();
  }
  // --------添加/编辑角色---------
  // --------快速创建角色---------
  private dialogQuickRoleVisible = false;
  private selectedRolenewly:any={
    job: '客服主管',
    content: '可以处理单位全部报修单，给全部工程师派单',
    isActive: true,
    id: 1
  }
  private rolenewly = [
    {
      job: '客服主管',
      content: '可以处理单位全部报修单，给全部工程师派单',
      isActive: false,
      id: 1
    },
    {
      job: '部门客服',
      content: '可以处理本部门的报修单，给部门工程师派单',
      isActive: false,
      id: 2
    },
    {
      job: '经理',
      content: '查看整体的维修（报修）统计表，后台设置及人员管理。',
      isActive: false,
      id: 4

    },
    {
      job: '工程师',
      content: '负责设备故障维修护理工作。',
      isActive: false,
      id: 3
    },
    {
      job: '工单池接单工程师',
      content: '适用于工单池接单，并且负责设备故障维修护理工作',
      isActive: false,
      id: 5
    }
  ];
  quickRoleHandle() {
    this.dialogQuickRoleVisible = true;
  }
  selectRoleHandle(val: any, index: number) {
    for (let i = 0; i < this.rolenewly.length; i++) {
      let cont = this.rolenewly[i];
      if (i !== index) {
        cont.isActive = false;
      }
    }
    val.isActive = true;
    this.selectedRolenewly = val;
    this.$set(this.rolenewly, index, val);
  }
  private createQuickRole() {
    if (!(this.selectedRolenewly && this.selectedRolenewly.isActive)) {
      this.showErrorMsg('请选择角色');
      return;
    }
    let pamars:any = {
      company_id: UserModule.getCompanyId,
      user_id: UserModule.getUserId,
      id: this.selectedRolenewly.id
    };
    quicklyCreateRole(pamars).then((res:any) => {
      this.dialogQuickRoleVisible = false;
      this.showSecussMsg(res.msg);
      this.getRoleList();
      this.getCompanyLimit();
    }).catch((err:any) => {
      this.showErrorMsg(err.msg);
    });
  }
  // --------快速创建角色---------
  // --------添加/删除人员---------
  private dialogSetStaffVisible = false;
  private dialogInviteDept = false;

  private addUserRoleId = '';
  private enterType = 0;
  addHandle(val: any) {
    this.enterType = 3;
    this.addUserRoleId = val.id;
    this.dialogSetStaffVisible = true;
  }
  deleteHandle(val: any) {
    this.enterType = 4;
    this.addUserRoleId = val.id;
    this.dialogSetStaffVisible = true;
  }
  closeHandle(value: boolean) {
    this.dialogSetStaffVisible = value;
    this.getRoleList();
    this.getCompanyLimit();
  }
  // --------添加/删除人员---------
  // --------删除角色---------
  delHandle(val: any) {
    this.$confirm('是否把' + val.role_name + '从角色列表删除?', '', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      const params = {
        company_id: UserModule.getCompanyId,
        company_role_id: val.id,
        user_id: UserModule.getUserId
      };
      deleteRole(params)
        .then((res:any) => {
          this.showSecussMsg(res.msg);
          this.getRoleList();
          this.getCompanyLimit();
        })
        .catch(err => {
          let msg = err.msg;
          this.showErrorMsg(msg);
        });
    }).catch(() => {

    });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
  // --------删除角色---------
}
